setUserUpdateData